import * as React from 'react';
import { OnClickOutside } from 'ui/common/on-click-outside';
import { withOpenState, OpenStateInjectedProps } from 'ui/common/enhancers';
import { keyCodeTypes } from 'ui/common/key-code-types';
import { Handlers, HotKeys, KeyMap } from 'ui/common/hotkeys';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { ModalSize } from 'app/components/constants';

import type { JSX } from "react";

interface DetailsModalTranslationProps {
  textHeaderTitle?: string;
  textDone?: string;
  className?: string;
  tooltip?: string;
}

export interface DetailsModalProps extends DetailsModalTranslationProps {
  editDetailsButton?: JSX.Element;
  children?: React.ReactNode;
}

export class DetailsModalComponent
  extends React.PureComponent<DetailsModalProps & OpenStateInjectedProps>  {
  private keyMap: KeyMap;
  private handlers: Handlers;
  public constructor(props: DetailsModalProps & OpenStateInjectedProps) {
    super(props);

    this.keyMap = {
      onEnter: [keyCodeTypes.Enter],
      onEsc: [keyCodeTypes.Esc]
    };

    this.handlers = {
      onEnter: () => this.closeModal,
      onEsc: () => this.closeModal()
    };
  }

  private closeModal = () => {
    const { isOpen, close } = this.props;
    if (!isOpen) {
      return;
    }
    close();
  };

  private renderModal() {
    const { children, textHeaderTitle, textDone } = this.props;

    return (
      <ModalWrapper
        headerTitle={textHeaderTitle}
        btnTitle={textDone}
        onClose={this.closeModal}
        onDone={this.closeModal}
        size={ModalSize.large}>
        {children}
      </ModalWrapper>
    );
  }

  public render() {
    const {
      open,
      isOpen,
      editDetailsButton,
      className,
      tooltip
    } = this.props;

    return <>
      <OnClickOutside onClickOutside={this.closeModal}>
        <HotKeys keyMap={this.keyMap} handlers={this.handlers}>
          <div className={className} onClick={open}>
            <span title={tooltip} >{editDetailsButton}</span>
            {isOpen && this.renderModal()}
          </div>
        </HotKeys>
      </OnClickOutside>
    </>;
  }
}

const c = withOpenState()(DetailsModalComponent);

export { c as DetailsModal };
